import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
} from "../../ui/ot";
import { CartesianGrid, Line, LineChart, XAxis, LabelList, Brush, YAxis } from "recharts"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
    ChartLegend, ChartLegendContent
} from "../../ui/chart"

const LineBasicChart = ({
    //數值類型的key
    chartConfig = {
        desktop: {
            label: "Desktop",
            color: "hsl(var(--chart-1))",
        },
        mobile: {
            label: "Mobile",
            color: "hsl(var(--chart-2))",
        },
    },
    //data
    chartData = [
        { month: "January", desktop: 186, mobile: 80 },
        { month: "February", desktop: 305, mobile: 200 },
        { month: "March", desktop: 237, mobile: 120 },
        { month: "April", desktop: 73, mobile: 190 },
        { month: "May", desktop: 209, mobile: 130 },
        { month: "June", desktop: 214, mobile: 140 },
    ],
    //X 軸顯示的名稱得key
    xDataKeyArr = ["month"],
    yDataKeyArr = ["desktop", 'mobile'],
    showLabel = true,
    showDot = false,
    lineType = "linear", // "natural" 、"linear"、 "step",
    showBrush = true
}) => {
   
    return (<Row>
        <Col span={24}>
            <ChartContainer config={chartConfig}>
                <LineChart
                    accessibilityLayer
                    data={chartData}
                    margin={{
                        left: 12,
                        right: 12,
                    }}
                >
                    <CartesianGrid vertical={false} />
                    <ChartLegend
                        className=" flex-wrap "
                        content={<ChartLegendContent />} />
                    <YAxis
                        type="number"
                        tickLine={false}
                        axisLine={false}
                        tickMargin={8}
                        domain={[0, 'dataMax + 10']}
                    />
                    {
                        xDataKeyArr.map((xDataKey) => (
                            <XAxis
                                dataKey={xDataKey}
                                tickLine={false}
                                axisLine={false}
                                tickMargin={8}
                                tickFormatter={(value) => value}
                            />
                        ))
                    }
                    <ChartTooltip
                        cursor={false}
                        content={<ChartTooltipContent hideLabel />}
                    />
                    {
                        yDataKeyArr.map((yDataKey) => {
                            return (
                                <Line
                                    dataKey={yDataKey}
                                    type={lineType}
                                    stroke={chartConfig[yDataKey]?.color}
                                    strokeWidth={2}
                                    dot={showDot && {
                                        fill: chartConfig[yDataKey]?.color,
                                    }}
                                    activeDot={{
                                        r: 6
                                    }}
                                >
                                    {showLabel && <LabelList
                                        position="top"
                                        offset={12}
                                        className="fill-foreground"
                                        fontSize={12}
                                    />}

                                </Line>
                            )
                        })
                    }
                    {showBrush && <Brush
                        height={20}
                    />}
                </LineChart>
            </ChartContainer>
        </Col>
    </Row>)
}
export { LineBasicChart }
